import { getConverterTypes } from 'src/utils/jobUtils';

const state = {
    converterTypes: null,
};

const actions = {
    // 获取convertertypes
    setConverterTypes(context) {
        getConverterTypes().then((res) => {
            context.commit('SET_CONVERTER_TYPES', res);
        })
    },
};

const mutations = {
    // 将convertertypes中的filetypes存入state
    SET_CONVERTER_TYPES(state, converterTypes) {
        state.converterTypes = converterTypes.filetypes;
    },
};

export default {
    state,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/fileConvert.js